const headers = {
  name: "Sales Returns",
  navigate: {
    path: [
      {
        name: "Returns",
        path: "/app/sales/returns",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
